// Single source for the fetch `credentials` mode.
//
// Auf NATIVEN Builds ist VITE_API_BASE gesetzt (z. B. https://app.lorath.eu) — die
// WebView laeuft unter dem Custom-Scheme-Origin `capacitor://localhost` und spricht
// die API damit CROSS-ORIGIN an. Die Auth laeuft dort ueber den Bearer-Header
// (Authorization), NICHT ueber Cookies. WKWebView lehnt Cross-Origin-Fetches mit
// `credentials: 'include'` von einem capacitor://-Origin ab (CORS-Credentialed-Check
// schlaegt fehl) -> i18n + alle Daten-Fetches scheiterten, die App zeigte nur rohe
// i18n-Keys ("funktioniert nicht"). Mit `omit` wird es ein normaler CORS-Request,
// der Bearer-Header bleibt erhalten (credentials steuert nur Cookies/TLS-Client-Certs,
// nicht Authorization).
//
// Auf WEB ist VITE_API_BASE leer (same-origin) bzw. same-site (.lorath.eu) -> dort
// bleibt Cookie-Auth mit `include` unveraendert.
export const API_CREDENTIALS: RequestCredentials =
  (import.meta.env.VITE_API_BASE ?? '') !== '' ? 'omit' : 'include';
